/* Custom: Split Showcase hover zoom — zooms only when the cursor is over the
   visible (drawn) part of the background image, accounting for object-fit:
   contain letterboxing. The panel link is also only clickable while the
   cursor is over the drawn image. */
(function () {
  function initSplitShowcaseZoom() {
    document.querySelectorAll('[id$="__section_kXN9Ug"] .group-block').forEach(function (block) {
      var img = block.querySelector('.group-block__media-wrapper img');
      if (!img || block.dataset.hoverZoomInit) return;
      block.dataset.hoverZoomInit = 'true';

      var link = block.querySelector('.group-block__link');

      function drawnRect() {
        var r = img.getBoundingClientRect();
        var fit = getComputedStyle(img).objectFit;
        if (fit !== 'contain' || !img.naturalWidth || !img.naturalHeight) return r;
        var scale = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
        var w = img.naturalWidth * scale;
        var h = img.naturalHeight * scale;
        var left = r.left + (r.width - w) / 2;
        var top = r.top + (r.height - h) / 2;
        return { left: left, top: top, right: left + w, bottom: top + h };
      }

      block.addEventListener('mousemove', function (e) {
        var r = drawnRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        img.classList.toggle('split-hover-zoom', inside);
        if (link) link.style.pointerEvents = inside ? 'auto' : 'none';
      });

      block.addEventListener('mouseleave', function () {
        img.classList.remove('split-hover-zoom');
        if (link) link.style.pointerEvents = 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSplitShowcaseZoom);
  } else {
    initSplitShowcaseZoom();
  }
  document.addEventListener('shopify:section:load', initSplitShowcaseZoom);
})();
